export const GET_SUBSCRIPTIONS_REQ = 'GET_SUBSCRIPTIONS_REQ';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_FAIL = 'GET_SUBSCRIPTIONS_FAIL';

export const BUY_SUBSCRIPTION_REQ = 'BUY_SUBSCRIPTION_REQ';
export const BUY_SUBSCRIPTION_SUCCESS = 'BUY_SUBSCRIPTION_SUCCESS';
export const BUY_SUBSCRIPTION_FAIL = 'BUY_SUBSCRIPTION_FAIL';
